import React, { useState, useContext, useEffect } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { HiOutlinePlusSm, HiOutlineMinusSm } from "react-icons/hi";
import ParameterContext from "../context/parameter/parameterContext";

import CryptoContext from "../context/crypto/cryptoContext";
import TradathonContext from "../context/tradathon/TradathonContext";
import { withRouter } from "react-router";
import { BiWallet } from "react-icons/bi";
import { formatPrice } from "../helpers/format";
import { GiTwoCoins } from "react-icons/gi";
import { toast } from "react-toastify";
import Message from "./Message";
import { FcInfo } from "react-icons/fc";
import ReactTooltip from "react-tooltip";
const TradathonModal = ({ location, from }) => {
  const { toggleVtradingModal, setOrderType, placeOrderType, vtButton } =
    useContext(ParameterContext);
  const {
    activeRoom,
    toggleTradathonModal,
    coinCSTAmount,
    editCoins,
    tradathon_setSellType,
    tradathon_placeOrder,
    tradathon_activeCrypto,
    tradathon_orderType,
    tradathon_activePrice,
    tradathon_modifyOrder,
    tradathon_placeStoplimitOrder,

    tradathon_placeMarketSellOrder,
    tradathon_placeMarketBuyOrder,
    setCoinCSTAmount,
    addCoins,
  } = useContext(TradathonContext);

  const { exchangeRate } = useContext(CryptoContext);
  //   const [CSTAmount, setOrder({...order,CSTAmount:] = useState(0);
  //   const [cryptoPrice, setCryptoPrice] = useState(Number(tradathon_activeCrypto.price));
  //   const [cryptoSellPrice, setCryptoSellPrice] = useState(tradathon_activePrice.price);
  const [message, setMessage] = useState({ status: 0, desc: "" });
  //   const [cursorType, setCursorType] = useState(false);
  const [portBalance, setPortBalance] = useState(
    activeRoom && activeRoom.balance
  );

  const [order, setOrder] = useState({
    amount:
      tradathon_orderType === "sell"
        ? tradathon_activePrice?.maxAmount
          ? tradathon_activePrice?.maxAmount
          : 1
        : 1,
    CSTAmount:
      location.pathname === "/tradathon/addcoins"
        ? activeRoom.room.rstatus === 0
          ? coinCSTAmount?.CSTAmount / exchangeRate
          : tradathon_activePrice.price
        : tradathon_activePrice.amount
        ? tradathon_activePrice.price * tradathon_activePrice.amount
        : tradathon_activePrice.price,
    buyPrice: tradathon_activePrice.price,
    sellPrice: tradathon_activePrice.price,
  });

  useEffect(() => {
    setOrderType("market");
    //eslint-disable-next-line
  }, [tradathon_orderType]);

  useEffect(() => {
    setOrder({
      amount: 1,
      CSTAmount: tradathon_activePrice.price,
      buyPrice: tradathon_activePrice.price,
      sellPrice: tradathon_activePrice.price,
    });
    //eslint-disable-next-line
  }, [placeOrderType]);
  useEffect(() => {
    if (
      activeRoom &&
      activeRoom.room.rstatus === 0 &&
      from &&
      from === "addcoins"
    ) {
      setPortBalance(
        activeRoom.balance +
          (coinCSTAmount?.singleInv ? coinCSTAmount.singleInv : 0)
      );
    }
    //eslint-disable-next-line
  }, [coinCSTAmount]);
  const handleChange = (e) => {
    let { name, value } = e.target;

    if (
      isFinite(value) &&
      !isNaN(value) &&
      typeof value !== "undefined" &&
      value !== null &&
      value !== ""
    ) {
      if (value === 0) {
        setOrder({ ...order, [name]: 0 });
      } else {
        if (name === "sellPrice") {
          setOrder({ ...order, sellPrice: value });
        }
        if (tradathon_orderType === "buy") {
          if (name === "amount") {
            if (order.buyPrice === "") {
              setOrder({
                ...order,
                [name]: value,
                CSTAmount: "",
              });
            } else {
              setOrder({
                ...order,
                [name]: value,
                CSTAmount: value * order.buyPrice,
              });
            }
          } else if (name === "CSTAmount") {
            if (order.buyPrice === "") {
              setOrder({
                ...order,
                [name]: value,
                amount: "",
              });
            } else {
              setOrder({
                ...order,
                [name]: value,
                amount:
                  value /
                  (placeOrderType === "market"
                    ? tradathon_activePrice.price
                    : order.buyPrice),
              });
            }
          } else if (name === "buyPrice") {
            if (order.CSTAmount === "") {
              setOrder({
                ...order,
                [name]: value,

                amount: "",
              });
            } else {
              setOrder({
                ...order,
                [name]: value,

                amount: order.CSTAmount / value,
              });
            }
          }
        } else if (tradathon_orderType === "sell") {
          if (name === "amount") {
            if (order.buyPrice === "") {
              setOrder({
                ...order,
                [name]: value,
                CSTAmount: "",
              });
            } else {
              setOrder({
                ...order,
                [name]: value,
                CSTAmount: value * order.buyPrice,
              });
            }
          } else if (name === "CSTAmount") {
            if (order.buyPrice === "") {
              setOrder({
                ...order,
                [name]: value,
                amount: "",
              });
            } else {
              setOrder({
                ...order,
                [name]: value,
                amount:
                  value /
                  (placeOrderType === "limit"
                    ? order.buyPrice
                    : tradathon_activePrice.price),
              });
            }
          } else if (name === "buyPrice") {
            if (order.amount === "") {
              setOrder({
                ...order,
                [name]: value,
                CSTAmount: "",
              });
            } else {
              setOrder({
                ...order,
                [name]: value,
                CSTAmount: value * order.amount,
              });
            }
          }
        }
      }
    } else {
      if (name === "buyPrice" && value === "") {
        setOrder({ ...order, CSTAmount: "", amount: "", buyPrice: "" });
      } else if ((name === "amount" || name === "CSTAmount") && value === "") {
        setOrder({ ...order, CSTAmount: "", amount: "" });
      } else setOrder({ ...order, ...order, [name]: "" });
    }
  };
  // const handleWalletAmount = (cstAmount) => {
  //   setOrder({
  //     ...order,
  //     CSTAmount: cstAmount,
  //     amount: cstAmount / order.buyPrice,
  //   });
  // };
  // const handleCoinAmount = (amount) => {
  //   setOrder({
  //     ...order,
  //     amount,
  //     CSTAmount: amount * order.buyPrice,
  //   });
  // };
  const handleIncrement = (e) => {
    const { id } = e.target;
    if (id === "sellPrice") {
      setOrder({ ...order, sellPrice: order.sellPrice + 1 });
    }
    if (tradathon_orderType === "buy") {
      if (id === "CSTAmount") {
        setOrder({
          ...order,
          CSTAmount: order.CSTAmount + 1,
          amount: (order.CSTAmount + 1) / order.buyPrice,
        });
      } else if (id === "amount") {
        setOrder({
          ...order,
          amount: order.amount + 1,
          CSTAmount: (order.amount + 1) * order.buyPrice,
        });
      } else if (id === "buyPrice") {
        setOrder({
          ...order,
          buyPrice: order.buyPrice + 1,
          amount: order.CSTAmount / (order.buyPrice + 1),
        });
      }
    } else if (tradathon_orderType === "sell") {
      if (id === "CSTAmount") {
        setOrder({
          ...order,
          CSTAmount: order.CSTAmount + 1,
          amount: (order.CSTAmount + 1) / order.buyPrice,
        });
      } else if (id === "amount") {
        setOrder({
          ...order,
          amount: order.amount + 1,
          CSTAmount: (order.amount + 1) * order.buyPrice,
        });
      } else if (id === "buyPrice") {
        setOrder({
          ...order,
          buyPrice: order.buyPrice + 1,
          CSTAmount: (order.buyPrice + 1) * order.amount,
        });
      }
    }
  };
  const handleDecrement = (e) => {
    const { id } = e.target;
    if (id === "sellPrice") {
      setOrder({ ...order, sellPrice: order.sellPrice - 1 });
    }
    if (tradathon_orderType === "buy") {
      if (id === "CSTAmount") {
        setOrder({
          ...order,
          CSTAmount: order.CSTAmount - 1,
          amount: (order.CSTAmount - 1) / order.buyPrice,
        });
      } else if (id === "amount") {
        setOrder({
          ...order,
          amount: order.amount - 1,
          CSTAmount: (order.amount - 1) * order.buyPrice,
        });
      } else if (id === "buyPrice") {
        setOrder({
          ...order,
          buyPrice: order.buyPrice - 1,
          amount: order.CSTAmount / (order.buyPrice - 1),
        });
      }
    } else if (tradathon_orderType === "sell") {
      if (id === "CSTAmount") {
        setOrder({
          ...order,
          CSTAmount: order.CSTAmount - 1,
          amount: (order.CSTAmount - 1) / order.buyPrice,
        });
      } else if (id === "amount") {
        setOrder({
          ...order,
          amount: order.amount - 1,
          CSTAmount: (order.amount - 1) * order.buyPrice,
        });
      } else if (id === "buyPrice") {
        setOrder({
          ...order,
          buyPrice: order.buyPrice - 1,
          CSTAmount: (order.buyPrice - 1) * order.amount,
        });
      }
    }
  };
  const handleBuyClick = (amount) => {
    //null check for sell Price
    if (
      order.amount === "" ||
      order.CSTAmount === "" ||
      order.buyPrice === ""
    ) {
      toast.error("Fields cannot be empty", { autoClose: 6000 });
    } else {
      toggleTradathonModal();
      tradathon_activePrice?.orderId
        ? tradathon_orderType === "buy"
          ? tradathon_modifyOrder(order.CSTAmount, order.amount)
          : tradathon_modifyOrder(order.amount, order.amount)
        : placeOrderType === "stoplimit"
        ? tradathon_placeStoplimitOrder({
            amount: order.amount,
            buyprice: order.buyPrice,
            sellprice: order.sellPrice,
          })
        : placeOrderType === "market" && tradathon_orderType === "buy"
        ? tradathon_placeMarketBuyOrder(order.CSTAmount)
        : placeOrderType === "market" && tradathon_orderType === "sell"
        ? tradathon_placeMarketSellOrder(order.amount)
        : tradathon_placeOrder(order.amount, order.buyPrice);

      toggleVtradingModal();
    }
  };
  return (
    <div className="Register">
      <div className="Modal__container" style={{ overflowY: "auto" }}>
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={() => {
              toggleTradathonModal();
              // setSellType("buy");
            }}
          />
        </div>
        <div className="Register__content">
          {activeRoom && activeRoom.room.rstatus === 1 && (
            <>
              <center>
                <div className="TradathonRoom__formContainer__toggleSwitch">
                  <div
                    className="TradathonRoom__formContainer_toggleSwitch__items"
                    style={{
                      color: tradathon_orderType === "buy" ? "#fff" : "#000",
                      background:
                        tradathon_orderType === "buy" ? "#8d0792" : "#eff2f5",
                    }}
                    onClick={() => {
                      tradathon_setSellType("buy");
                    }}
                  >
                    <h4>BUY</h4>
                  </div>

                  <div
                    className="TradathonRoom__formContainer_toggleSwitch__items"
                    style={{
                      color: tradathon_orderType === "buy" ? "#000" : "#fff",
                      background:
                        tradathon_orderType === "buy" ? "#eff2f5" : " #E93848",
                    }}
                    onClick={() => {
                      tradathon_setSellType("sell");
                    }}
                  >
                    <h4>SELL</h4>
                  </div>
                </div>
              </center>

              <div className="Modal__header">
                <p
                  onClick={() => setOrderType("limit")}
                  style={{
                    color: placeOrderType === "limit" ? "#8d0792" : "#000",
                  }}
                >
                  Limit
                </p>
                <p
                  onClick={() => setOrderType("market")}
                  style={{
                    color: placeOrderType === "market" ? "#8d0792" : "#000",
                  }}
                >
                  Market
                </p>
                {tradathon_orderType === "buy" &&
                  !location.pathname.split("/").includes("room") &&
                  vtButton !== "openOrder" && (
                    <p
                      onClick={() => setOrderType("stoplimit")}
                      style={{
                        color:
                          placeOrderType === "stoplimit" ? "#8d0792" : "#000",
                      }}
                    >
                      Stop Limit
                    </p>
                  )}
              </div>

              <div>
                <>
                  {placeOrderType !== "stoplimit" && (
                    <>
                      <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                        AT Price
                      </h4>
                      <div className="ModalContent__set">
                        <input
                          type="number"
                          min="0"
                          name="buyPrice"
                          value={order.buyPrice}
                          readOnly={placeOrderType === "market" ? true : false}
                          onChange={handleChange}
                        />
                        {placeOrderType !== "market" && (
                          <div className="ModalContent__icons">
                            <button
                              style={{
                                background: "#e8ecf0",
                                cursor: "pointer",
                                visibility:
                                  order.price <= 1 ? "hidden" : "visible",
                              }}
                              onClick={handleDecrement}
                            >
                              <HiOutlineMinusSm size={18} id="buyPrice" />
                            </button>
                            <button
                              style={{
                                background:
                                  tradathon_orderType === "buy"
                                    ? "rgba(69, 170, 67, 1)"
                                    : "#E93848",
                                color: "white",
                                cursor: "pointer",
                              }}
                              onClick={handleIncrement}
                            >
                              <HiOutlinePlusSm size={18} id="buyPrice" />
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  <>
                    {placeOrderType === "stoplimit" && (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "50px",
                          cursor: "pointer",
                          borderBottom: "2px solid #BABABA",
                        }}
                      >
                        <div>
                          <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                            AT Price
                          </h4>
                          <div
                            className="ModalContent__set"
                            style={{ border: 0 }}
                          >
                            <input
                              type="number"
                              min="0"
                              name="buyPrice"
                              value={order.buyPrice}
                              onChange={handleChange}
                              style={{ width: "50%" }}
                            />

                            <div className="ModalContent__icons">
                              <button
                                style={{
                                  background: "#e8ecf0",
                                  cursor: "pointer",
                                  visibility:
                                    order.price <= 1 ? "hidden" : "visible",
                                }}
                                onClick={handleDecrement}
                              >
                                <HiOutlineMinusSm size={18} id="buyPrice" />
                              </button>
                              <button
                                style={{
                                  background:
                                    tradathon_orderType === "buy"
                                      ? "rgba(69, 170, 67, 1)"
                                      : "#E93848",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                                onClick={handleIncrement}
                              >
                                <HiOutlinePlusSm size={18} id="buyPrice" />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                            Sell Price
                          </h4>
                          <div
                            className="ModalContent__set"
                            style={{ border: 0 }}
                          >
                            <input
                              type="number"
                              min="0"
                              name="sellPrice"
                              value={order.sellPrice}
                              onChange={handleChange}
                              style={{ width: "50%" }}
                            />
                            <div className="ModalContent__icons">
                              <button
                                style={{
                                  background: "#e8ecf0",
                                  cursor: "pointer",
                                  visibility:
                                    order.sellPrice <= 1 ? "hidden" : "visible",
                                }}
                                onClick={handleDecrement}
                              >
                                <HiOutlineMinusSm size={18} id="sellPrice" />
                              </button>
                              <button
                                style={{
                                  background: "#E93848",
                                  color: "white",
                                  cursor: "pointer",
                                  visibility:
                                    order.sellPrice === ""
                                      ? "hidden"
                                      : "visible",
                                }}
                                onClick={handleIncrement}
                              >
                                <HiOutlinePlusSm size={18} id="sellPrice" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                        Amount|
                        <span style={{ color: "#BABABA" }}>
                          {tradathon_activeCrypto.symbol}
                        </span>
                      </h4>
                      {tradathon_orderType === "buy" && (
                        <>
                          <ReactTooltip
                            place="top"
                            effect="float"
                            multiline={true}
                            id="info"
                          />
                          <FcInfo
                            size={26}
                            data-for="info"
                            data-tip="Amount that you are viewing<br />now, can differ slightly after buying,<br/> due to high price fluctuations"
                          />
                        </>
                      )}{" "}
                    </div>

                    <div className="ModalContent__set">
                      <input
                        name="amount"
                        type="number"
                        min="0"
                        value={order.amount}
                        readOnly={
                          placeOrderType === "market" &&
                          tradathon_orderType === "buy"
                        }
                        onChange={handleChange}
                      />
                      {!(
                        placeOrderType === "market" &&
                        tradathon_orderType === "buy"
                      ) && (
                        <div className="ModalContent__icons">
                          <button
                            style={{
                              background: "#e8ecf0",
                              cursor: "pointer",
                              visibility:
                                order.amount <= 1 ? "hidden" : "visible",
                            }}
                            onClick={handleDecrement}
                          >
                            <HiOutlineMinusSm size={18} id="amount" />
                          </button>
                          <button
                            style={{
                              background:
                                tradathon_orderType === "buy"
                                  ? "rgba(69, 170, 67, 1)"
                                  : "#E93848",
                              color: "white",
                              cursor: "pointer",
                              visibility:
                                order.amount === "" ? "hidden" : "visible",
                            }}
                            onClick={handleIncrement}
                          >
                            <HiOutlinePlusSm size={18} id="amount" />
                          </button>
                        </div>
                      )}
                    </div>
                  </>
                </>

                <p></p>
                <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                  Total Amount| <span style={{ color: "#BABABA" }}>CST</span>
                </h4>
                <div className="ModalContent__set">
                  <input
                    type="number"
                    name="CSTAmount"
                    min="0"
                    value={order.CSTAmount}
                    readOnly={
                      placeOrderType === "market" &&
                      tradathon_orderType === "sell"
                    }
                    onChange={handleChange}
                  />
                  {!(
                    placeOrderType === "market" &&
                    tradathon_orderType === "sell"
                  ) && (
                    <div className="ModalContent__icons">
                      <button
                        style={{
                          background: "#e8ecf0",
                          cursor: "pointer",
                          visibility:
                            order.CSTAmount <= 1 ? "hidden" : "visible",
                        }}
                        onClick={handleDecrement}
                      >
                        <HiOutlineMinusSm size={18} id="CSTAmount" />
                      </button>
                      <button
                        style={{
                          background:
                            tradathon_orderType === "buy"
                              ? "rgba(69, 170, 67, 1)"
                              : "#E93848",
                          color: "white",
                          cursor: "pointer",
                          visibility:
                            order.CSTAmount === "" ? "hidden" : "visible",
                        }}
                        onClick={handleIncrement}
                      >
                        <HiOutlinePlusSm size={18} id="CSTAmount" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {activeRoom && activeRoom.room.rstatus === 0 ? (
            coinCSTAmount?.CSTAmount ? (
              <>
                <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                  Total Amount Invested|{" "}
                  <span style={{ color: "#BABABA" }}>CST</span>
                </h4>
                <div className="ModalContent__set">
                  <input
                    type="number"
                    min="0"
                    value={coinCSTAmount.CSTAmount}
                    onChange={(e) =>
                      setCoinCSTAmount({
                        ...coinCSTAmount,
                        CSTAmount: e.target.value,
                      })
                    }
                  />
                  <div className="ModalContent__icons">
                    <button
                      style={{ background: "#e8ecf0", cursor: "pointer" }}
                      onClick={() =>
                        setCoinCSTAmount({
                          ...coinCSTAmount,
                          CSTAmount: coinCSTAmount.CSTAmount - 1,
                        })
                      }
                    >
                      <HiOutlineMinusSm size={18} />
                    </button>
                    <button
                      style={{
                        background:
                          tradathon_orderType === "buy"
                            ? "rgba(69, 170, 67, 1)"
                            : "#E93848",
                        color: "white",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setCoinCSTAmount({
                          ...coinCSTAmount,
                          CSTAmount: coinCSTAmount.CSTAmount + 1,
                        })
                      }
                    >
                      <HiOutlinePlusSm size={18} />
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                  Total Amount| <span style={{ color: "#BABABA" }}>CST</span>
                </h4>
                <div className="ModalContent__set">
                  <input
                    type="number"
                    min="0"
                    readOnly={
                      placeOrderType === "market" &&
                      tradathon_orderType === "sell"
                    }
                    name="CSTAmount"
                    value={order.CSTAmount}
                    onChange={handleChange}
                  />
                  {!(
                    placeOrderType === "market" &&
                    tradathon_orderType === "sell"
                  ) && (
                    <div className="ModalContent__icons">
                      <button
                        style={{ background: "#e8ecf0", cursor: "pointer" }}
                        id="CSTAmount"
                        onClick={handleDecrement}
                      >
                        <HiOutlineMinusSm size={18} />
                      </button>
                      <button
                        style={{
                          background:
                            tradathon_orderType === "buy"
                              ? "rgba(69, 170, 67, 1)"
                              : "#E93848",
                          color: "white",
                          cursor: "pointer",
                        }}
                        id="CSTAmount"
                        onClick={handleIncrement}
                      >
                        <HiOutlinePlusSm size={18} />
                      </button>
                    </div>
                  )}
                </div>
              </>
            )
          ) : (
            <></>
          )}

          {message.status === 1 && <Message desc={message.desc} type="error" />}

          {activeRoom && tradathon_orderType === "buy" && (
            <div className="ModalContent__wallet">
              <div
                className="ModalContent__wallet_CST"
                style={{ justifySelf: "start" }}
              >
                <BiWallet size={20} />
                <p style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>
                  {`${formatPrice(portBalance / exchangeRate)} CST`}
                </p>
              </div>
              <div className="ModalContent__wallet-percent">
                <div
                  onClick={() => {
                    setOrder({
                      ...order,
                      CSTAmount: (0.25 * portBalance) / exchangeRate,
                      amount:
                        (0.25 * portBalance) / order.buyPrice / exchangeRate,
                    });
                    activeRoom.room.rstatus === 0 &&
                      setCoinCSTAmount({
                        ...coinCSTAmount,
                        CSTAmount: (0.25 * portBalance) / exchangeRate,
                      });
                  }}
                >
                  25%
                </div>
                <div
                  onClick={() => {
                    setOrder({
                      ...order,
                      CSTAmount: (0.5 * portBalance) / exchangeRate,
                      amount:
                        (0.5 * portBalance) / order.buyPrice / exchangeRate,
                    });
                    activeRoom.room.rstatus === 0 &&
                      setCoinCSTAmount({
                        ...coinCSTAmount,
                        CSTAmount: (0.5 * portBalance) / exchangeRate,
                      });
                  }}
                >
                  50%
                </div>
                <div
                  onClick={() => {
                    setOrder({
                      ...order,
                      CSTAmount: (0.75 * portBalance) / exchangeRate,
                      amount:
                        (0.75 * portBalance) / order.buyPrice / exchangeRate,
                    });
                    activeRoom.room.rstatus === 0 &&
                      setCoinCSTAmount({
                        ...coinCSTAmount,
                        CSTAmount: (0.75 * portBalance) / exchangeRate,
                      });
                  }}
                >
                  75%
                </div>
                <div
                  onClick={() => {
                    setOrder({
                      ...order,
                      CSTAmount: portBalance / exchangeRate,
                      amount: portBalance / order.buyPrice / exchangeRate,
                    });
                    activeRoom.room.rstatus === 0 &&
                      setCoinCSTAmount({
                        ...coinCSTAmount,
                        CSTAmount: portBalance / exchangeRate,
                      });
                  }}
                >
                  100%
                </div>
              </div>
            </div>
          )}

          {tradathon_orderType === "sell" && activeRoom && (
            <div className="ModalContent__wallet">
              <div
                className="ModalContent__wallet_CST"
                style={{ justifySelf: "start", gap: "10px" }}
              >
                <GiTwoCoins size={20} />
                <p style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>
                  {tradathon_activePrice.maxAmount}
                </p>
              </div>
              <div className="ModalContent__wallet-percent">
                <div
                  onClick={() => {
                    setOrder({
                      ...order,
                      amount: 0.25 * tradathon_activePrice.maxAmount,
                      CSTAmount:
                        tradathon_activeCrypto.price *
                        (0.25 * tradathon_activePrice.maxAmount),
                    });
                  }}
                >
                  25%
                </div>
                <div
                  onClick={() => {
                    setOrder({
                      ...order,
                      amount: 0.5 * tradathon_activePrice.maxAmount,
                      CSTAmount:
                        tradathon_activeCrypto.price *
                        (0.5 * tradathon_activePrice.maxAmount),
                    });
                  }}
                >
                  50%
                </div>
                <div
                  onClick={() => {
                    setOrder({
                      ...order,
                      amount: 0.75 * tradathon_activePrice.maxAmount,
                      CSTAmount:
                        tradathon_activeCrypto.price *
                        (0.75 * tradathon_activePrice.maxAmount),
                    });
                  }}
                >
                  75%
                </div>
                <div
                  onClick={() => {
                    setOrder({
                      ...order,
                      CSTAmount:
                        tradathon_activeCrypto.price *
                        tradathon_activePrice.maxAmount,

                      amount: tradathon_activePrice.maxAmount,
                    });
                  }}
                >
                  100%
                </div>
              </div>
            </div>
          )}
        </div>

        <button
          className="TradathonRoom__join__button"
          style={{
            background:
              tradathon_orderType === "buy"
                ? "rgba(69, 170, 67, 1)"
                : "#E93848",
            borderRadius: "5px",
            width: "100%",
            cursor: message.status ? "not-allowed" : "pointer",
          }}
          onClick={() => {
            activeRoom && activeRoom.room.rstatus === 1
              ? handleBuyClick()
              : location.pathname.split("/").includes("room") ||
                location.pathname.split("/").includes("addcoins")
              ? editCoins(order.CSTAmount) && toggleTradathonModal()
              : addCoins({
                  rmid: activeRoom._id,
                  rid: activeRoom.rid,
                  coins: [
                    {
                      cname: tradathon_activeCrypto.symbol,
                      cstAmount: order.CSTAmount,
                    },
                  ],
                }) && toggleTradathonModal();
          }}
          disabled={message.status}
        >
          {location.pathname !== "/tradathon/screen"
            ? tradathon_orderType.toUpperCase()
            : "ADD COIN"}
        </button>
      </div>
    </div>
  );
};

export default withRouter(TradathonModal);
